// Module
var code = "<svg viewBox=\"0 0 20 20\" fill=currentColor> <path d=\"M6 13a4 4 0 010-8 4 4 0 118 0 4 4 0 010 8h-3V8a1 1 0 10-2 0v5H6zM9 13h2v2.586l1.293-1.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 111.414-1.414L9 15.586V13z\"/> </svg> ";
// Exports
module.exports = code;